import pickBy from 'lodash/pickBy';
import isUndefined from 'lodash/isUndefined';
import isBoolean from 'lodash/isBoolean';

import {DATASET_MIXPANEL} from 'common/report/constants';

import {ClauseType} from './types';

export class CohortsClause {
  static TYPE: typeof ClauseType.Cohorts = ClauseType.Cohorts;
  dataset: string;
  id: number;
  name: string;
  negated: boolean;
  raw_cohort: any;
  data_group_id: string;

  constructor(attrs: any = {}) {
    this.dataset = attrs.dataset;
    this.dataset = this.dataset === `mixpanel` ? DATASET_MIXPANEL : this.dataset;
    this.id = attrs.id;
    this.name = attrs.name;
    this.negated = attrs.negated || false;
    // Raw cohorts are not saved on the backend
    // and instead are directly passed through
    // from query-api to arb

    // eslint-disable-next-line camelcase
    this.raw_cohort = attrs.raw_cohort || null;
    // eslint-disable-next-line camelcase
    this.data_group_id = attrs.data_group_id || ``;
  }

  extend(attrs = {}) {
    return new CohortsClause({...this.attrs, ...attrs});
  }

  get attrs() {
    const {id, name, negated} = this;
    return pickBy(
      {
        dataset: this.dataset,
        id,
        name,
        negated,
        raw_cohort: this.raw_cohort,
        ...(this.data_group_id ? {data_group_id: this.data_group_id} : {}),
      },
      (value) => !isUndefined(value),
    );
  }

  get valid() {
    return !!(isBoolean(this.negated) && (this.raw_cohort || (this.id && this.name)));
  }

  get isInlineCohort() {
    return !!this.getInlineCohort();
  }

  getInlineCohort() {
    return this.raw_cohort && this.attrs;
  }

  serialize() {
    return this.attrs;
  }

  toUrlData() {
    return this.attrs;
  }

  toBookmarkData() {
    return this.attrs;
  }
}
